import { Components, Theme } from '@mui/material';

import { typographyVariants } from '../typographyVariants';

export const MuiTypography: Partial<Components<Theme>> = {
  MuiTypography: {
    variants: typographyVariants,
  },
};
